import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import ReactPaginate from "react-paginate";
import _ from "lodash";
import "./Custom.css";
import "../loader.css";

function ScenarioList(props) {
  const userRole = localStorage.getItem("URole");
  const mangerId = localStorage.getItem("ManegerId");

  const [ScenarioList, setScenarioList] = useState([]);
  const [ScenarioList2, setScenarioList2] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [Record, seRecord] = useState([]);
  const [paginatedPosts, setpaginatedPosts] = useState();
  const navigate = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [filterText, setfilterText] = useState("");
  const [casesLimit, setCasesLimit] = useState("");
  const [casesRemaining, setCasesRemaining] = useState("");
  const [hasFocus, setHasFocus] = useState(false);

  let pageSize = 10;

  useEffect(() => {
    // userRole === "Admin"
    //   ? LoadScenario()
    //   : LoadPortalScenario();

    if (userRole === "Admin") {
      LoadScenario();
    } else {
      LoadPortalScenario();
      LoadCasesLimit();
    }
  }, [pageSize]);

  const LoadScenario = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/GetAllScenario`).then((res) => {
      seRecord(res.data.length);
      if (res.data.length > 10) {
        setScenarioList(res.data);
        setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
      } else {
        setScenarioList2(res.data);
      }
      setIsLoading(false);
    });
  };

  const LoadPortalScenario = () => {
    const datavalue = {
      managerId: mangerId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetAllPortalScenario`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    axios(authOptions).then((res) => {
      seRecord(res.data.length);
      if (res.data.length > 10) {
        setScenarioList(res.data);
        setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
      } else {
        setScenarioList2(res.data);
      }
      setIsLoading(false);
    });
  };

  const LoadCasesLimit = () => {
    const datavalue = {
      managerId: mangerId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetCasesLimit`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    axios(authOptions).then((res) => {
      var casesLimitData = res.data.data;
      const casesRemaining = parseInt(casesLimitData.cases_Remaining);
      const casesLimit = parseInt(casesLimitData.cases_Limit);
      const totalCasesLimit = parseInt(casesLimitData.total_Cases_Limit);
      const limit = totalCasesLimit > 0 ? totalCasesLimit : casesLimit;

      if (limit > 0) {
        setCasesLimit(limit);
        setCasesRemaining(casesRemaining);
      } else {
        setCasesLimit("");
        setCasesRemaining("");
      }
    }).catch((err) => {
      console.log(err);
    });
  };

  const pageCount = ScenarioList ? Math.ceil(ScenarioList.length / pageSize) : 0;
  if (pageCount === 1) return null;
  const pages = _.range(1, pageCount + 1);

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setCurrentPage(currentPage);
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedPost = _(ScenarioList)
      .slice(startIndex)
      .take(pageSize)
      .value();
    setpaginatedPosts(paginatedPost);
  };

  const EditScenario = (valid) => {
    localStorage.setItem("ScenarioId", valid);
  };

  const deleteScenario = (value) => {
    const datavalue = {
      scenarioId: value,
    };
    // Extract token from localStorage.state
    let token = null;
    try {
      const raw = localStorage.getItem("state");
      if (raw) {
        const state = JSON.parse(raw);
        token = state.auth?.token;
      }
    } catch (e) {
      console.error("Token parsing failed", e);
    }
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeleteScenario`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
    };
    axios(authOptions)
      .then((res) => {

        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };
  const BackFunc = () => {
    navigate.push("/index");
  };

  const onClearClicked = () => {
    setfilterText("");
    userRole === "Admin"
      ? LoadScenario()
      : LoadPortalScenario();
  };

  const FilterCases = () => {
    setIsLoading(true);
    if (filterText === "") {
      userRole === "Admin"
        ? LoadScenario()
        : LoadPortalScenario();
    } else {
      const datavalue = {
        searchString: filterText,
      };

      if (userRole == "Manager") {
        datavalue.managerId = mangerId;
      }

      var apiUrl = process.env.REACT_APP_API_URL + "/GetPortalScenarioByName";

      if (userRole == "Admin") {
        apiUrl = process.env.REACT_APP_API_URL + "/GetScenarioByName";
      }


      var authOptions = {
        method: "post",
        url: apiUrl,
        data: datavalue,
        headers: { "Content-Type": "multipart/form-data" },
      };
      axios(authOptions).then((res) => {
        seRecord(res.data.length);
        if (res.data.length > 10) {
          setScenarioList(res.data);
          setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
        } else {
          setScenarioList2(res.data);
        }
        setIsLoading(false);
      });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && hasFocus) {
      FilterCases();
    }
  };

  const handleFocus = () => {
    setHasFocus(true);
  };

  const handleBlur = () => {
    setHasFocus(false);
  };

  return (
    <>
      <div className="page-content-wrapper">
        {isLoading ? (
          <div className="page-content d-flex justify-content-center align-items-center">
            <div className="my-wrapper">
              <div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
            </div>

          </div>
        )
          : (
            <div className="page-content">
              <div className="page-bar">
                <div className="page-title-breadcrumb">
                  <div className=" pull-left">
                    <div className="page-title my-0">List of Scenarios</div>
                  </div>
                </div>
                <div className="page-title-breadcrumb">
                  <div className=" pull-right">
                    <button
                      type="submit"
                      className="btn btn-primary d-inline-block"
                      onClick={BackFunc}
                    >
                      {" "}
                      <i className="fa fa-arrow-left" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-head">
                          {/* <header>Patient List</header> */}
                          <header>
                            <div class="d-flex justify-content-between mb-3">
                              <span id="txtTotalCases" style={{ color: "#1e2e38", fontWeight: "600" }}>
                                {casesLimit && `Total Cases : ${Record}`}
                              </span>

                              <span id="txtCasesRemaining" style={{ color: "#1e2e38", fontWeight: "600" }}>
                                {casesLimit && `Cases Remaining : ${casesRemaining}/${casesLimit}`}
                              </span>
                            </div>

                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <input
                                  type="text"
                                  value={filterText}
                                  placeholder="Search by Scenario Name"
                                  onChange={(e) => setfilterText(e.target.value)}
                                  onKeyDown={handleKeyDown}
                                  onFocus={handleFocus}
                                  onBlur={handleBlur}
                                  autoFocus={true}
                                  style={{ borderTopRightRadius: "0px", borderBottomRightRadius: "0px" }}
                                  className="form-control" />
                              </div>

                              <button
                                type="button"
                                className="btn btn-primary py-2 px-3 me-2 shadow-none"
                                onClick={FilterCases}
                                style={{ border: "1px solid #1e2b38", borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px" }}
                              >
                                <i className="fa fa-search"></i>
                              </button>

                              <button
                                type="button"
                                className="btn py-2 px-3 shadow-none"
                                onClick={onClearClicked}
                                style={{ backgroundColor: "#15bd8c", color: "#FFF", border: "1px solid #15bd8c", borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px" }}
                              >
                                Clear
                              </button>
                            </div>

                          </header>
                          <div className="tools">
                          </div>
                        </div>
                        <div className="card-body ">
                          <div className="table-responsive">
                            <table className="table table-striped custom-table table-hover" style={{ tableLayout: "fixed" }}>
                              <thead>
                                <tr>
                                  <th>Scenario ID</th>
                                  <th width="25%"> Scenario Name</th>
                                  <th width="25%">Scenario Location</th>
                                  <th width="25%">Scenario URL</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Record > 10
                                  ? paginatedPosts &&
                                  paginatedPosts.length > 0 &&
                                  paginatedPosts.map((item) => (
                                    <tr>
                                      <td className="text-left">{item.scenario_Id}</td>
                                      <td>
                                        <Link
                                          to="/UpdateScenario"
                                          onClick={() => EditScenario(item.scenario_Id)}
                                          className=""
                                        >
                                          <a href="#">{item.scenario_Name}</a>
                                        </Link>
                                      </td>
                                      <td className="text-left">
                                        {item.scenario_Location}
                                      </td>
                                      <td className="text-left" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                                        <a target="_blank" href={item.case_Url}>{item.case_Url}</a>
                                      </td>

                                      <td>
                                        <Link
                                          to="/UpdateScenario"
                                          onClick={() => EditScenario(item.scenario_Id)}
                                          className="btn btn-primary btn-xs py-2"
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </Link>
                                        <button
                                          className="btn btn-danger btn-xs py-2"
                                          onClick={() => {
                                            Swal.fire({
                                              title: "Are you sure?",
                                              text: "You won't be able to revert this!",
                                              icon: "warning",
                                              showCancelButton: true,
                                              confirmButtonColor: "#6777ef",
                                              cancelButtonColor: "#d33",
                                              confirmButtonText:
                                                "Yes, delete it!",
                                            }).then((result) => {
                                              if (result.isConfirmed) {
                                                deleteScenario(item.scenario_Id);
                                              }
                                            });
                                          }}
                                        >
                                          <i className="fa fa-trash-o "></i>
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                  : ScenarioList2 &&
                                  ScenarioList2.length > 0 &&
                                  ScenarioList2.map((item) => (
                                    <tr>
                                      <td className="text-left">{item.scenario_Id}</td>
                                      <td>
                                        <Link
                                          to="/UpdateScenario"
                                          onClick={() => EditScenario(item.scenario_Id)}
                                          className=""
                                        >
                                          <a href="#">{item.scenario_Name}</a>
                                        </Link>
                                      </td>
                                      <td className="text-left">
                                        {item.scenario_Location}
                                      </td>
                                      <td className="text-left" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                                        <a target="_blank" href={item.case_Url}>{item.case_Url}</a>
                                      </td>

                                      <td>
                                        <Link
                                          to="/UpdateScenario"
                                          onClick={() => EditScenario(item.scenario_Id)}
                                          className="btn btn-primary btn-xs py-2"
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </Link>
                                        <button
                                          className="btn btn-danger btn-xs py-2"
                                          onClick={() => {
                                            Swal.fire({
                                              title: "Are you sure?",
                                              text: "You won't be able to revert this!",
                                              icon: "warning",
                                              showCancelButton: true,
                                              confirmButtonColor: "#6777ef",
                                              cancelButtonColor: "#d33",
                                              confirmButtonText:
                                                "Yes, delete it!",
                                            }).then((result) => {
                                              if (result.isConfirmed) {
                                                deleteScenario(item.scenario_Id);
                                              }
                                            });
                                          }}
                                        >
                                          <i className="fa fa-trash-o "></i>
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                          {Record > 10 ? (
                            <ReactPaginate
                              previousLabel={"Prev"}
                              nextLabel={"Next"}
                              breakLabel={"..."}
                              pageCount={pageCount}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={3}
                              onPageChange={handlePageClick}
                              containerClassName={
                                "pagination justify-content-center"
                              }
                              pageClassName={"page-item"}
                              pageLinkClassName={"page-link"}
                              activeClassName={"active"}
                              previousClassName={"page-item"}
                              nextClassName={"page-item"}
                              previousLinkClassName={"page-link"}
                              nextLinkClassName={"page-link"}
                            />
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
      </div>
    </>
  );
}

export default ScenarioList;
